// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import InlineAlertBar from '../inline-alert-bar/index';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import {hasAccess} from '../../services/security';

export const pageSecurityWrapper = (module, feature) =>
    WrappedComponent => {

        const PageSecurityWrappedComponent = (props, context) =>
            hasAccess(context.security, module, feature) ?
                <WrappedComponent{...props}/> :
                <InlineAlertBar
                    label='ACCESS_DENIED'
                    type='error'
                />;

        PageSecurityWrappedComponent.WrappedComponent = WrappedComponent;
        PageSecurityWrappedComponent.contextTypes = {
            security: PropTypes.instanceOf(Security).isRequired
        };

        return PageSecurityWrappedComponent;

    };



// WEBPACK FOOTER //
// ./src/shared/components/security-wrapper/page-security-wrapper.js